export default function Marquee() {
  const items = [
    "HUSTLE.",
    "SWAGGER.",
    "BIG STICK ENERGY.",
    "FEARLESS.",
    "LOUD STICKS.",
    "QUIET HEARTS.",
    "BIG STICK ENERGY.",
  ];
  const loop = [...items, ...items];

  return (
    <section
      data-testid="marquee-section"
      aria-label="Energy marquee"
      className="relative bg-[#0a0a0a] py-10 md:py-14 overflow-hidden"
    >
      <div className="absolute inset-x-0 top-0 h-px bg-neutral-900" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-neutral-900" />

      {/* Red stripe */}
      <div className="relative -rotate-[2deg] bg-[#e11d2a] py-5 md:py-7 shadow-[0_0_40px_rgba(225,29,42,0.25)]">
        <div className="flex whitespace-nowrap animate-marquee">
          {loop.map((t, i) => (
            <span
              key={i}
              className="font-anton uppercase text-white text-4xl md:text-6xl tracking-tighter px-6 flex items-center gap-6"
            >
              {t}
              <span className="inline-block w-3 h-3 rotate-45 bg-white" />
            </span>
          ))}
        </div>
      </div>

      {/* Thin navy stripe below for the red/white/blue tricolor moment */}
      <div className="relative mt-3 rotate-[1.2deg] bg-[#1b2f5c] py-2 overflow-hidden">
        <div className="flex whitespace-nowrap animate-marquee" style={{ animationDuration: "40s" }}>
          {loop.map((t, i) => (
            <span
              key={`b-${i}`}
              className="font-anton uppercase text-white/90 text-lg md:text-2xl tracking-[0.2em] px-6 flex items-center gap-4"
            >
              ★ {t}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
